import React from 'react';
import LazyPageLoader from '../../cmp/LazyPageLoader';
import {useParams} from "react-router-dom";

const Page = React.lazy(()=>import('./CustomPage'))

export default function CustomPageLazy(props){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page {...props} />
    </React.Suspense>
}


